import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TabNavigationContext } from './tab-navigation-context';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 * @prop {boolean} [disabled]
 * @prop {() => void} [onClick]
 * @prop {number} [tabKey]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifTabControl = (props) => {
  const { children, className = '', disabled = false, onClick = null, tabKey = 0, ...others } = props;
  const { activeTab, setActiveTab, currentTab, buttonRefs, lineSide } = useContext(
    TabNavigationContext
  );

  const onTabClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    setActiveTab(tabKey);
  };

  const classes = classNames({
    'motif-tab-button': true,
    'motif-active': !disabled && tabKey === activeTab,
    'motif-tab-line-left': lineSide === 'left',
    'motif-tab-line-right': lineSide === 'right',
    [className]: true
  });

  return (
    <button
      ref={element => {
        buttonRefs.current[tabKey] = element;
      }}
      type="button"
      className={classes}
      role="tab"
      onClick={(event) => onTabClick(event)}
      disabled={disabled}
      tabIndex={tabKey === currentTab && !disabled ? '0' : '-1'}
      aria-selected={tabKey === activeTab && !disabled}
      {...others}
    >
      {children}
    </button>
  );
};

MotifTabControl.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tabKey: PropTypes.number
};

export { MotifTabControl };
